import { libProvideTransloco, provideUI } from '@akmf/ngx-ui-lib';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import localePl from '@angular/common/locales/pl';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  LOCALE_ID,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { ApiConfiguration } from '@api';
import { TranslocoService, provideTransloco } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';
import { TokenInterceptor } from 'src/app/core/interceptors/token.interceptor';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { errorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';

registerLocaleData(localePl);

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: preloadTranslation,
      multi: true,
      deps: [TranslocoService],
    },
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([TokenInterceptor, errorHandlerInterceptor]),
      withFetch()
    ),
    { provide: ApiConfiguration, useValue: { rootUrl: environment.apiUrl } },
    provideTransloco({
      config: {
        availableLangs: ['pl'],
        defaultLang: 'pl',
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    { provide: LOCALE_ID, useValue: 'pl' },
    provideUI(),
    libProvideTransloco(false),
  ],
};

export function preloadTranslation(transloco: TranslocoService) {
  return (): Promise<any> => {
    transloco.setActiveLang('pl');
    return firstValueFrom(transloco.load('pl'));
  };
}
